import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=a0d3b8a0&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ContactInfo.vue?vue&type=script&lang=js&"
export * from "./ContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=a0d3b8a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d3b8a0",
  null
  
)

export default component.exports